export interface GameMeta {
  id: string;
  title: string;
  description: string;
  icon: string;
  /** Kommt in P2 — noch keine Spiele implementiert */
  available: boolean;
}

/** Spiele-Katalog — wird mit P2/P4 erweitert */
export const games: GameMeta[] = [
  {
    id: 'zahlenstrahl',
    title: 'Zahlenstrahl',
    description: 'Platziere Zahlen am richtigen Ort!',
    icon: '📊',
    available: true,
  },
  {
    id: 'memory3d',
    title: '3D-Memory',
    description: 'Findle die passenden Paare im 3D-Raum!',
    icon: '🃏',
    available: true,
  },
  {
    id: 'tangram',
    title: 'Tangram',
    description: 'Lege Formen aus geometrischen Teilen!',
    icon: '🧩',
    available: true,
  },
  {
    id: 'buchstaben',
    title: 'Buchstaben',
    description: 'Finde den Anfangsbuchstaben des Bildes!',
    icon: '🔤',
    available: true,
  },
  {
    id: 'rechen-monster',
    title: 'Rechen-Monster',
    description: 'Übe die vier Grundrechenarten mit dem Monster!',
    icon: '🧮',
    available: true,
  },
];
